import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-pdf-dialog',
    templateUrl: './pdf-dialog.component.html',
    styleUrls: ['./pdf-dialog.component.scss']
})
export class PdfDialogComponent implements OnInit {

    pdfFile: any;
    isFormLoading = false;

    constructor(
        private dialogRef: MatDialogRef<PdfDialogComponent>,
        private toastr: ToastrService,
        @Inject(MAT_DIALOG_DATA) dialogData?: any) {
        this.pdfFile = dialogData;
    }

    ngOnInit() {
    }

    onLoadComplete($event: any) {
        this.isFormLoading = false;
    }

    onLoadError(error: any) {
        this.toastr.error('Document downloaded failed!');
    }

    onClose() {
        this.dialogRef.close();
    }

}
